"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-fuel_label" }, null, -1);
const _hoisted_5 = { key: 1 };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-rain_label" }, null, -1);
const _hoisted_7 = { key: 2 };
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-noise_label" }, null, -1);
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TyreLabelingCell',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.tyreLabelingColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `tyre-labeling-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('tyre_labeling', 'Tyre labeling', 'tyre_labeling_cell')), 1),
                    (0, vue_2.createElementVNode)("div", null, [
                        (__props.product.fuelEfficiency)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                _hoisted_4,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.product.fuelEfficiency), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.wetGripClass)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                _hoisted_6,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.product.wetGripClass), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.noiseMeasurementValue)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                _hoisted_8,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.product.noiseMeasurementValue) + "dB ", 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
